import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useSnackbar } from 'notistack';

import { addAttractionOffer } from '~/services/AttractionsService';

import { setCacheBuster } from './attractionCacheBuster';
import { attractionQueryKeys } from './attractionQueryKeys';

interface AddAttractionOfferData {
  attractionId: string;
  offerId: string;
}

export function useAddAttractionOffer() {
  const queryClient = useQueryClient();
  const { enqueueSnackbar } = useSnackbar();

  return useMutation({
    mutationFn: async ({ attractionId, offerId }: AddAttractionOfferData) => {
      return await addAttractionOffer(attractionId, offerId);
    },
    onSuccess: (_data, { attractionId }) => {
      queryClient.invalidateQueries({ queryKey: attractionQueryKeys.offers(attractionId) });
      queryClient.invalidateQueries({ queryKey: attractionQueryKeys.lists() });
      queryClient.invalidateQueries({ queryKey: attractionQueryKeys.detail(attractionId) });
      setCacheBuster(attractionId, Date.now().toString());
      enqueueSnackbar('Offer linked to attraction', { variant: 'success' });
    },
    onError: (error: Error) => {
      enqueueSnackbar(`Error linking offer: ${error.message || 'Unknown error'}`, { variant: 'error' });
    },
  });
}
